<template>
  <div class="select-box-input-1 mb-3">
    <h5 class="select-box-input-1-title" v-html="inputConfig.title"></h5>
    <p v-html="inputConfig.description"></p>


    <div class="btn btn-primary rounded-pill mb-2 select-box-input-1-selected-item" v-if="selectedItem != null">
      <i class="bi bi-x-circle-fill mx-1 " @click="resetInput"></i>
      {{ selectedItem.label }}
    </div>


    <div class="form-group select-box-input-1-wrapper">
      <input @focusin="toggleList" required v-model="searchWords" type="text"
             class="form-control select-box-input-1-input"
             ref="autocomplete-list"
             placeholder="جست وجو">
      <div class="select-box-input-1-list bg-white mt-1 rounded w-100 border p-1 d-none" ref="select-box-input">
        <div class="select-box-input-1-list-item border-bottom  p-2" v-for="(option,index) in optionsStep"
             @click="chooseOptionItem(option)">
          {{ option }}
        </div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "SelectBoxWithFilter",
  props: {
    inputConfig: {},
    formAnswer: {}
  },
  data() {
    return {
      selectedItem: null,
      searchWords: '',
      selectedOption: '',
      selectedOptionIndex: 0,
      storeSelectedItemList: [],
    }
  },
  computed: {
    options() {
      return this.inputConfig.options.filter(item => {
        return item.label.indexOf(this.searchWords) > -1
      })
    },
    optionsStep() {
      let result = [];
      let optionIndex = (this.storeSelectedItemList.length - 1)

      this.options.forEach(option => {
        let parts = option.label.split(':');

        if (this.selectedOption === '') {
          // Show the first level options (e.g., "apple", "samsung")
          if (result.indexOf(parts[0]) === -1) {
            result.push(parts[0]);
          }
        } else {
          if (parts[optionIndex] == this.selectedOption) {
            let nextLevel = parts[optionIndex + 1]
            if (result.indexOf(nextLevel) === -1 && nextLevel !== undefined) {
              result.push(nextLevel);
            }
          }
        }
      });

      return result;
    },
  },
  methods: {
    toggleList() {
      this.$refs["select-box-input"].classList.toggle('d-none')
    },
    chooseItem(item) {
      this.toggleList()
      this.formAnswer[this.inputConfig.id] = item.id
      this.selectedItem = item
      this.$refs["autocomplete-list"].required = false
    },
    chooseOptionItem(item) {
      this.selectedOption = item
      this.storeSelectedItemList.push(item)
      if (this.optionsStep.length === 0) {
        // find item inside options
        let result = this.inputConfig.options.find(item => {
          return item.label == this.storeSelectedItemList.join(':')
        })

        this.chooseItem(result)
      }
    },
    resetInput() {
      this.selectedItem = null
      this.searchWords = ''
      this.selectedOption = ''
      this.selectedOptionIndex = 0
      this.storeSelectedItemList = []
    }
  },
}
</script>

<style scoped>
.select-box-input-1-list-item {
  cursor: pointer;
  transition: ease-in-out .3s all;
}

.select-box-input-1-list-item:hover {
  transition: ease-in-out .3s all;
  background: #d9d9d9;
}

.select-box-input-1-list {
  overflow: auto;
  height: 150px;
}

</style>